<template>
  <nav class="navbar" :class="{ 'scrolled': isScrolled, 'menu-open': isMobileMenuOpen }">
    <div class="navbar-container">
      <!-- Logo with animated glow -->
      <a class="logo" aria-label="Invextia" href="#home" @click="closeMobileMenu">
        <div class="logo-wrapper">
          <img src="@/assets/logo2.png" alt="Invextia Logo" />
          <div class="logo-glow"></div>
        </div>
      </a>

      <!-- Desktop nav with premium animations -->
      <ul class="nav-links">
        <li v-for="(item, index) in navItems" :key="index" class="nav-item">
          <a 
            :href="item.href" 
            class="nav-link"
            @click="handleNavClick"
            :style="{ '--delay': index * 0.1 + 's' }"
          >
            <span class="nav-text">{{ $t(item.label) }}</span>
            <div class="nav-indicator"></div>
            <div class="nav-ripple"></div>
          </a>
        </li>
      </ul>

      <!-- Right side controls -->
      <div class="nav-controls">
        <!-- Language toggle with premium styling -->
        <div class="lang-container" aria-label="Language">
          <LangSwitcher />
        </div>

        <!-- Mobile menu button -->
        <button 
          class="mobile-menu-btn" 
          :class="{ active: isMobileMenuOpen }"
          @click="toggleMobileMenu"
          aria-label="Toggle menu"
        >
          <span class="menu-line"></span>
          <span class="menu-line"></span>
          <span class="menu-line"></span>
        </button>
      </div>
    </div>

    <!-- Mobile menu overlay -->
    <div class="mobile-menu" :class="{ active: isMobileMenuOpen }">
      <div class="mobile-menu-content">
        <ul class="mobile-nav-links">
          <li v-for="(item, index) in navItems" :key="index" class="mobile-nav-item">
            <a 
              :href="item.href" 
              class="mobile-nav-link"
              @click="closeMobileMenu"
              :style="{ '--delay': index * 0.1 + 's' }"
            >
              <span class="mobile-nav-text">{{ $t(item.label) }}</span>
              <div class="mobile-nav-arrow">→</div>
            </a>
          </li>
        </ul>
        <div class="mobile-menu-footer">
          <div class="mobile-lang-container">
            <LangSwitcher />
          </div>
        </div>
      </div>
    </div>

    <!-- Background blur overlay for mobile -->
    <div class="mobile-overlay" :class="{ active: isMobileMenuOpen }" @click="closeMobileMenu"></div>
  </nav>
</template>

<script>
import LangSwitcher from '@/components/LangSwitcher.vue';

export default {
  name: 'HeaderSection',
  components: { LangSwitcher },
  data() {
    return {
      isScrolled: false,
      isMobileMenuOpen: false,
      // Actualizado con tus nuevas secciones
      navItems: [
        { href: '#home',         label: 'nav.home' },
        { href: '#about',        label: 'nav.about' },
        { href: '#contact',      label: 'nav.contact' },
        { href: '#dashboard',    label: 'nav.dashboard' },
        { href: '#skills',       label: 'nav.skills' },
        { href: '#pricing', label: 'nav.pricing' },
        { href: '#faq',    label: 'nav.faq' }
        
      ]
    };
  },
  mounted() {
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 20;
    },
    handleResize() {
      if (window.innerWidth > 768 && this.isMobileMenuOpen) {
        this.closeMobileMenu();
      }
    },
    handleKeydown(e) {
      if (e.key === 'Escape' && this.isMobileMenuOpen) {
        this.closeMobileMenu();
      }
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
      document.body.style.overflow = this.isMobileMenuOpen ? 'hidden' : '';
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
      document.body.style.overflow = '';
    },
    handleNavClick(e) {
      // Ripple
      const link = e.currentTarget;
      const ripple = link.querySelector('.nav-ripple');
      const rect = link.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height);
      const x = e.clientX - rect.left - size / 2;
      const y = e.clientY - rect.top - size / 2;
      
      ripple.style.width = ripple.style.height = size + 'px';
      ripple.style.left = x + 'px';
      ripple.style.top = y + 'px';
      ripple.classList.add('animate');
      setTimeout(() => ripple.classList.remove('animate'), 600);

      // Si quieres smooth scroll nativo (opcional) al hacer click:
      // Si el href es ancla local, prevenimos comportamiento y hacemos scroll suave.
      const href = link.getAttribute('href');
      if (href && href.startsWith('#')) {
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          this.closeMobileMenu();
        }
      }
    }
  }
};
</script>

<style scoped src="@/styles/Header-Section.css"></style>
